const BaseProductProductGroupInitialValues = (showData) => ({
  base_product_code: showData?.data?.base_product_code || "",
  sport_id: showData?.data?.sport?.id || "",
  product_id: showData?.data?.product?.id || "",
  team_id: showData?.data?.team?.id || "",
  term_id: showData?.data?.term?.id || "",
  edition_id: showData?.data?.edition?.id || "",
  brand_id: showData?.data?.brand?.id || "",
  competition_id: showData?.data?.competition?.id || "",
});

export default BaseProductProductGroupInitialValues;
